// extracted by mini-css-extract-plugin
export default {"iframe":"DonateModal_iframe_B3Qtq","overlay":"DonateModal_overlay_OuadH"};